export const blockIconsTextformattingDesignServicesNew = (
	<span className='material-symbols-outlined'>design_services</span>
);
